import { render, staticRenderFns } from "./Disc.vue?vue&type=template&id=8225d1b0&scoped=true"
import script from "./Disc.vue?vue&type=script&lang=js"
export * from "./Disc.vue?vue&type=script&lang=js"
import style0 from "./Disc.vue?vue&type=style&index=0&id=8225d1b0&prod&lang=scss"
import style1 from "./Disc.vue?vue&type=style&index=1&id=8225d1b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8225d1b0",
  null
  
)

export default component.exports